var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5983 0.132996C5.10939 0.132996 0.0427246 5.02188 0.0427246 11.2441C0.0427246 12.6219 0.576058 15.3774 1.46495 17.3774C4.35384 23.9997 10.6649 31.5108 10.9316 31.8219C11.1094 32.0441 11.3316 32.133 11.5983 32.133C11.8649 32.133 12.0872 31.9997 12.2649 31.8219C12.5316 31.5108 18.8427 23.9997 21.7316 17.3774C22.6205 15.3774 23.1538 12.6219 23.1538 11.2441C23.1538 5.02188 18.0872 0.132996 11.5983 0.132996ZM20.0872 16.6663C17.8649 21.7774 13.3316 27.6886 11.5983 29.8219C9.86495 27.6886 5.33161 21.7774 3.10939 16.6663C2.30939 14.933 1.8205 12.4441 1.8205 11.2441C1.8205 5.99966 6.13161 1.91077 11.5983 1.91077C17.0649 1.91077 21.3761 5.99966 21.3761 11.2441C21.3761 12.4441 20.8872 14.933 20.0872 16.6663Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5983 5.46631C8.1761 5.46631 5.3761 8.26631 5.3761 11.6885C5.3761 15.1108 8.1761 17.9108 11.5983 17.9108C15.0205 17.9108 17.8205 15.1108 17.8205 11.6885C17.8205 8.26631 15.0205 5.46631 11.5983 5.46631ZM11.5983 16.133C9.15388 16.133 7.15388 14.133 7.15388 11.6885C7.15388 9.24409 9.15388 7.24409 11.5983 7.24409C14.0428 7.24409 16.0428 9.24409 16.0428 11.6885C16.0428 14.133 14.0428 16.133 11.5983 16.133Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDark);
export default __webpack_public_path__ + "static/media/map-dark.ae664591ce58cd4d54cb6fdb9609a36e.svg";
export { ForwardRef as ReactComponent };